import DiligencePage, { diligenceQuery } from "@app/pages/diligence/diligence-page";
import type { diligencePage_Query } from "@app/queries/diligencePage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/diligence")({
  loader: () =>
    loadQuery<diligencePage_Query>(
      environment,
      diligenceQuery,
      {},
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Diligence"),
  component: DiligenceRoute,
});

function DiligenceRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading diligence data</div>}
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Building the diligence pack…</div>
        }
      >
        <DiligencePage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
